import "./index.scss";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import { IconCode, IconLocked } from "@icons/index";
import report from "@report";
import { TestId } from "@shared/testIds";
import { updateLoginMethod } from "@store/globalSlice";
import { Trans } from "react-i18next";
import { twMerge } from "tailwind-merge";

const revertLoginMap = {
  email: "email_password",
  email_password: "email",
  sms: "password",
  password: "sms",
};

const ChangeLoginMode = ({ className }: { className?: string }) => {
  const { loginMethod } = useAppSelector((state) => state.globalReducer);
  const dispatch = useAppDispatch();
  const isPassword = !(loginMethod === "email" || loginMethod === "sms");
  const phoneAccount = (revertLoginMap as any)[loginMethod];

  return (
    <div className={twMerge("Component_ChangeLoginMode text-kds-fg-soft text-[14px]", className)}>
      <div
        className="right-text"
        data-testid={isPassword ? TestId.SwitchToCodeLogin : TestId.SwitchToPasswordLogin}
        onClick={() => {
          dispatch(updateLoginMethod(phoneAccount));
          report.click({
            kalo_pos: isPassword ? "Login_with_code" : "Login_with_password",
          });
        }}
      >
        {isPassword && (
          <>
            <IconCode className="change_icon"></IconCode>
            <Trans>Log in with code</Trans>
          </>
        )}
        {!isPassword && (
          <>
            <IconLocked className="change_icon"></IconLocked>
            <Trans>Log in with password</Trans>
          </>
        )}
      </div>
    </div>
  );
};

export default ChangeLoginMode;
